export const CONSUMER_TOKEN_KEY = 'accessConsumerToken';
